import { useMemo, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { createColumns } from "../../../helpers";
import { DATATABLE_CUSTOM_STYLES } from "../../../constants/datatableStyles";
import CustomPagination from "../../../Components/CustomPagination";
import PageTitle from "../../../Components/UI/PageTitle";
import RowLoader from "../../../Components/UI/RowLoader";
import { getMyVouchers } from "../../../apis";

const MyVouchers = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(
    parseInt(new URLSearchParams(location.search).get("page"), 10) || 1
  );
  const [isLoading, setIsLoading] = useState(true);
  const [vouchersData, setVouchersData] = useState([]);
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    setIsLoading(true);
    getMyVouchers(currentPage)
      .then((response) => {
        const { data } = response;
        const { data: vouchersData, paginator } = data || {};

        setVouchersData(vouchersData || []);
        setPagination({
          last_page: paginator.last_page ?? 1,
          current_page: paginator.current_page ?? 1,
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage]);

  useEffect(() => {
    const params = new URLSearchParams();

    params.set("page", currentPage);

    navigate({ search: params.toString() });
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const filterAndSortData = () => {
    return vouchersData;
  };

  const hiddenColumns = [
    "id",
    "action",
    "must_verify_email",
    "client_id",
    "can_be_deleted",
  ]; // Add column keys you want to hide

  const columns = useMemo(() => {
    return createColumns(vouchersData, [], hiddenColumns, true).map((col) => ({
      ...col,

      sortable: false,
      width: col.name === "Num" ? "80px" : "1fr",
    }));
  }, [vouchersData]);

  return (
    <>
      <PageTitle title="My Vouchers" />
      <div className="bg-white flex flex-col mt-4">
        <div className="bg-white shadow-lg rounded-lg flex flex-col p-2 gap-2 mb-5">
          <DataTable
            columns={columns}
            data={filterAndSortData()}
            customStyles={DATATABLE_CUSTOM_STYLES}
            progressPending={isLoading}
            progressComponent={<RowLoader />}
            defaultSortAsc
          />

          <div className="flex justify-center mt-4">
            <CustomPagination
              totalPages={pagination?.last_page}
              currentPage={pagination?.current_page || 1}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MyVouchers;
